<div id="preview-container" class="preview-container">
  @if (waTemplate | async; as template) {
    @if (template.id != '_ERROR_') {
      <ng-container class="preview">
        <div class="preview-content">
          @if (template.templateContent.header && template.templateContent.header; as header) {
            <div class="preview-header"
              >
              @if (header.type) {
                @switch (header.type) {
                  @case ('media') {
                    <img id="media-preview-header" src="./assets/wa-template/{{header.media.type}}.svg">
                  }
                  @case ('location') {
                    <img id="location-preview-header" src="./assets/wa-template/location.svg">
                  }
                  @case ('text') {
                    <label id="text-preview-header" class="preview-header-text">
                      {{ header.text.text }}
                    </label>
                  }
                }
              }
            </div>
          }
          <div id="preview-body" class="preview-body">
            {{ template.templateContent.body.text }}
          </div>
          @if (template.templateContent.footer; as footer) {
            <div id="preview-footer" class="preview-footer">
              {{ footer }}
            </div>
          }
        </div>
        @if (template.templateContent.buttons; as buttons) {
          <div class="preview-buttons">
            @for (button of buttons | waTemplateButtonPipe; track button) {
              @switch (button.type) {
                @case (TemplateContentButtonType.DIAL) {
                  <div id="preview-buttons-{{button.index}}" class="preview-button"
                    >
                    <label class="preview-button-text" matTooltipPosition="above"
                      matTooltip="{{button.content.phoneNumber}}">
                      <img src="./assets/wa-template/phone.svg" width="14" height="14">
                      {{ button.content.text }}
                    </label>
                  </div>
                }
                @case (TemplateContentButtonType.WEB_SITE_URL) {
                  <div id="preview-buttons-{{button.index}}" class="preview-button"
                    >
                    <label class="preview-button-text" matTooltipPosition="above"
                      matTooltip="{{button.content.url}}">
                      <img src="./assets/wa-template/link.svg" width="14" height="14">
                      {{ button.content.text }}
                    </label>
                  </div>
                }
                @case (TemplateContentButtonType.QUICK_REPLY) {
                  <div id="preview-buttons-{{button.index}}" class="preview-button"
                    >
                    <label class="preview-button-text">
                      {{ button.content.text }}
                    </label>
                  </div>
                }
                @case (TemplateContentButtonType.COPY_CODE) {
                  <div id="preview-buttons-{{button.index}}" class="preview-button"
                    >
                    <label class="preview-button-text">
                      <img src="./assets/wa-template/copy-icon.svg" width="15" height="15">
                      {{ button.content.text }}
                    </label>
                  </div>
                }
                @case (TemplateContentButtonType.OTP) {
                  <div id="preview-buttons-{{button.index}}" class="preview-button"
                    >
                    <label class="preview-button-text">
                      <img src="./assets/wa-template/copy-icon.svg" width="15" height="15">
                      {{ button.content.text }}
                    </label>
                  </div>
                }
                @case (TemplateContentButtonType.CATALOG) {
                  <div id="preview-buttons-{{button.index}}" class="preview-button"
                    >
                    <label class="preview-button-text">
                      {{ button.content.text }}
                    </label>
                  </div>
                }
              }
            }
          </div>
        }
      </ng-container>
    } @else {
      <div class="preview-content">
        <div class="preview-content-error">
          Template not found
        </div>
      </div>
    }
  } @else {
    <div class="preview-content">
      <loading-icon></loading-icon>
    </div>
  }
</div>


